import type { RouteRecordRaw } from "vue-router"

const list: RouteRecordRaw[] = [
    {
        path: "/position",
        name: "人员定位管理系统",
        component: () => import("@/views/position/index"),
        redirect: "/position/real",
        children: [
            {
                path: 'real',
                name: '实时位置 - 人员定位管理系统',
                component: () => import("@/views/position/real/index"),
                meta: {
                    KeepAlive: true,
                    title: "实时位置 - 人员定位管理系统",
                    tools: ['clear', 'personDisplay', 'viewControl']
                }
            },
            {
                path: 'fence',
                name: '电子围栏 - 人员定位管理系统',
                component: () => import("@/views/position/fence/index"),
                meta: {
                    KeepAlive: true,
                    title: "电子围栏 - 人员定位管理系统",
                    tools: ['viewControl']
                }
            },
            {
                path: 'track',
                name: '历史轨迹 - 人员定位管理系统',
                component: () => import("@/views/position/track/index"),
                meta: {
                    KeepAlive: true,
                    title: "历史轨迹 - 人员定位管理系统",
                    tools: ['viewControl']
                }
            },
            {
                path: 'heatmap',
                name: '热力图 - 人员定位管理系统',
                component: () => import("@/views/position/heatmap/index"),
                meta: {
                    KeepAlive: true,
                    title: "热力图 - 人员定位管理系统",
                    tools: ['viewControl']
                }
            },
            // {
            //     path: 'gather',
            //     name: '人员定位管理系统 - 风险聚集',
            //     component: () => import("@/views/position/gather/index"),
            //     meta: {
            //         KeepAlive: true,
            //         title: "人员定位管理系统 - 风险聚集",
            //         tools: ['viewControl']
            //     }
            // },
            {
                path: 'monitoring',
                name: '实时画面 - 人员定位管理系统',
                component: () => import("@/views/position/monitoring/index"),
                meta: {
                    KeepAlive: true,
                    title: "实时画面 - 人员定位管理系统",
                    tools: ['viewControl']
                }
            },
            {
                path: 'areaTrack',
                name: '位置追踪 - 人员定位管理系统',
                component: () => import("@/views/position/areaTrack/index"),
                meta: {
                    KeepAlive: true,
                    title: "位置追踪 - 人员定位管理系统",
                    tools: ['viewControl']
                }
            },
            {
                path: 'drill',
                name: '应急演练 - 人员定位管理系统',
                component: () => import("@/views/position/drill/index"),
                meta: {
                    KeepAlive: true,
                    title: "应急演练 - 人员定位管理系统",
                    tools: ['viewControl']
                }
            },
            {
                path: 'emergency',
                name: '作业地图 - 应急管理管理系统',
                component: () => import("@/views/position/emergency/index"),
                meta: {
                    KeepAlive: true,
                    title: "作业地图 - 应急管理管理系统",
                    tools: ['viewControl']
                }
            }
        ]
    },
    {
        path: '/position/work',
        redirect: '/work'
    },
    {
        path: '/work',
        name: '作业地图 - 人员定位管理系统',
        component: () => import('@/views/work/index.vue'),
        meta: {
            KeepAlive: true,
            title: "作业地图 - 人员定位管理系统",
            tools: ['viewControl']
        }
    },
    {
        path: '/emergency',
        name: '巡检系统 - 智能巡检系统',
        component: () => import('@/views/emergency/index.vue'),
        meta: {
            KeepAlive: true,
            title: "巡检系统 - 智能巡检系统",
            tools: ['viewControl']
        }
    },
    {
        path: '/history-track',
        name: '巡检系统 - 巡检记录',
        component: () => import('@/views/historyTrack/HistoryTrack'),
        meta: {
            KeepAlive: true,
            title: "巡检系统 - 巡检记录",
            tools: ['viewControl']
        }
    }
]
export default list
